var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(false === _vm.data)?_c('p',[_vm._v("\n        Something went wrong. Please refresh the page and try again.\n    ")]):(!_vm.data)?_c('base-loader'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }